export default __webpack_public_path__ + "static/media/clean-shipping-discounts-icon.883ac221.png";